import React, { useEffect, useState } from "react";
import styles from "./kyc.module.css";
import { Pagination } from "antd";
import { useNavigate } from "react-router-dom";
import Config from "../../service/Config";
import { CircularProgress } from "@mui/material";

const Kyc = ({ title }) => {
  const navigate = useNavigate();

  // server-side paging/sorting
  const [page, setPage] = useState(1); // 1-based
  const [pageSize, setPageSize] = useState(10);

  // data + ui state
  const [items, setItems] = useState([]);
  const [refresh, setRefersh] = useState(false);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  let tokens = localStorage.getItem("authToken");
  let parsedTokens = JSON.parse(tokens);

  const API_BASE = Config.kyc_api_endpoint;

  useEffect(() => {
    const controller = new AbortController();
    try {
      let token = localStorage.getItem("authToken");
      let parsedToken = token ? JSON.parse(token) : {};
      console.log("parsedToken", parsedToken);
      if (!parsedToken.IdToken || !parsedToken.AccessToken) {
        localStorage.removeItem("authToken");
        navigate("/login");
      }
      (async () => {
        setLoading(true);
        setError("");
        try {
          const res = await fetch(`${API_BASE}/advanced-kyc/all-data`, {
            method: "POST",
            signal: controller.signal,
            headers: {
              "Content-Type": "application/json",
              aws_cognito_id_token: parsedToken.IdToken,
              aws_cognito_access_token: parsedToken.AccessToken,
            },
            body: JSON.stringify({
              page,
              limit: pageSize,
              // include_provider: false,
            }),
          });
          const json = await res.json();
          if (!res.ok || !json.success) {
            throw new Error(json?.error || "Request failed");
          }
          setItems(Array.isArray(json.data) ? json.data : []);
          setTotal(Number(json?.meta?.total ?? 0));
        } catch (e) {
          if (e.name !== "AbortError")
            setError(e.message || "Something went wrong");
        } finally {
          setLoading(false);
        }
      })();
    } catch (err) {
      console.log("error", err);
    }
    return () => controller.abort();
  }, [API_BASE, page, pageSize, refresh]);

  // simple client-side filter on current page results (optional)
  const visibleRows = search
    ? items.filter((row) => {
        const s = search.toLowerCase();
        return (
          row.name?.toLowerCase().includes(s) ||
          row.email?.toLowerCase().includes(s) ||
          row.phone?.toLowerCase().includes(s) ||
          row.company_name?.toLowerCase().includes(s) ||
          row.status?.toLowerCase().includes(s)
        );
      })
    : items;

  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(255,255,255,0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
          }}
        >
          <CircularProgress size={60} sx={{ color: "#2348AB" }} />
        </div>
      )}
      <div className={styles.frameGroup}>
        <div className={styles.feeStatementDataTable}>
          <div className={styles.top}>
            <div className={styles.filterWrapper}>
              <div className={styles.filter}>
                <div className={styles.containertext}>
                  {title || "Company KYC (Advanced)"}
                </div>
              </div>

              <div className={styles.filter}>
                <div className={styles.textField}>
                  <div className={styles.content}>
                    <img
                      className={styles.leadingIcon}
                      alt=""
                      src="/leadingicon.svg"
                    />
                    <input
                      className={styles.labelText1}
                      placeholder="Search name, email, phone, status…"
                      type="text"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                </div>

                <button
                  className={styles.reLoadTable}
                  onClick={() => {
                    setSearch("");
                    setPage(1);
                    setRefersh(!refresh);
                  }}
                >
                  <img
                    className={styles.vectorIcon1}
                    alt=""
                    src="/vector7.svg"
                  />
                </button>
              </div>
            </div>

            <div className={styles.topChild} />
          </div>

          {error && (
            <div style={{ color: "#B00020", padding: 12 }}>Error: {error}</div>
          )}
          {loading && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                background: "rgba(255,255,255,0.7)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 2000,
              }}
            >
              <CircularProgress size={60} sx={{ color: "#2348AB" }} />
            </div>
          )}

          {!loading && (
            <table className={styles.table}>
              <thead className={styles.tableHead}>
                <tr className={styles.tableHeaderRow}>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.head}>DATE</div>
                  </th>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.head}>COMPANY REP.</div>
                  </th>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.head}>COMPANY NAME</div>
                  </th>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.head}>BUSSINESS TYPE</div>
                  </th>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.head}>STATUS</div>
                  </th>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.head}>ACTION</div>
                  </th>
                </tr>
              </thead>

              <tbody className={styles.tableHead}>
                {visibleRows.map((row) =>{ 
                  console.log("row",row)
                  return(
                  <tr
                    // key={`${row._id || row.company_id}-${row.created_at || ""}`}
                    key={`${row.company_id}-${row.created_at}`}
                    className={styles.tableBodyrow}
                  >
                    <td className={styles.tableBodydatabtn}>
                      <div className={styles.data12}>
                        {row.created_at
                          ? new Date(row.created_at).toLocaleDateString()
                          : "—"}
                      </div>
                    </td>
                    <td className={styles.tableBodydata}>
                      <div className={styles.data1}>{row.name || "—"}</div>
                    </td>
                    <td className={styles.tableBodydata}>
                      <div className={styles.data1}>
                        {row.company_name || "—"}
                      </div>
                    </td>
                    <td className={styles.tableBodydata}>
                      <div className={styles.data1}>
                        {row.entity_type || "—"}
                      </div>
                    </td>
                    <td className={styles.tableBodydata}>
                      <div className={styles.data1}>{row.status || "—"}</div>
                    </td>
                    <td className={styles.tableBodydata}>
                      <button
                        className={styles.button}
                        onClick={() =>
                          navigate(
                            `/content/kyc/${row.company_id}/${encodeURIComponent(row.entity_type)}`
                          )
                        }
                      >
                        <img alt="" src="/eye.svg" className={styles.btn_img} />
                        View More
                      </button>
                    </td>
                  </tr>
                )})}
                {visibleRows.length === 0 && (
                  <tr>
                    <td colSpan={6} className={styles.tableBodydata}>
                      <div className={styles.data1}>No records found.</div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}

          <div className={styles.bottom}>
            <Pagination
              current={page}
              pageSize={pageSize}
              total={total}
              onChange={(p, ps) => {
                setPage(p);
                setPageSize(ps);
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Kyc;
